<script setup lang="ts">
import { VDrawerClose } from '~kui/vendor/vaul/drawer'
import { DialogClose } from 'reka-ui'

import { useCredenzaContext } from './credenzaContext'

interface Props {
  asChild?: boolean;
}

withDefaults(defineProps<Props>(), {
  asChild: true,
})

const { isMobile } = useCredenzaContext()
const Comp = computed(() =>
  isMobile.value ? VDrawerClose : DialogClose,
)
</script>

<template>
  <component
    :is="Comp"
    :as-child="asChild"
  >
    <slot />
  </component>
</template>
